import KeyboardAnimator from "../components/KeyboardAnimator";

const HomePage = () => {
  return <KeyboardAnimator animateWord="typing duck." />;
};

export default HomePage;
